'use client';
import { saveAICookieForShopify, saveCookieForShopify } from 'eco-design-micro/common/CookieForShopify';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { fetchPostWeb } from 'eco-design-micro/request2/FetchClient';
import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';
import { loginUser } from 'eco-design-micro/utils-user/web/webToken';
import gtm from 'eco-design-reliance/gtm';
import StoreIconA from './IconA';
const authSignIn = async (params: any, otherParmas: any) => {
    return fetchPostWeb('/auth/signIn', params, otherParmas);
};
export default function StoreCommon({ prefixCls, locale, StoreTextA = {} }: { prefixCls: string; locale: string; StoreTextA: any }) {
    // https://project.feishu.cn/mz820/story/detail/7024981194?parentUrl=%2Fmz820%2FstoryView%2Fg4Gvv2v4R%3Fscope%3Dworkspaces%26node%3D10447129&scope=workspaces&node=10447129&openScene=4
    const storeMap: Record<string, string> = {
        cn: 'https://mall.jd.com/index-1000363402.html',
        // 欧洲
        ru: 'https://ecoflow-russia.com/', // 俄罗斯
        pl: 'https://ecoflow.com.pl/', // 波兰
        se: 'https://ecoflow.se/', // 瑞典
        tr: 'https://ecoflow.com.tr/', // 土耳其
        ch: 'https://ch.ecoflow.com/', // 瑞士
        ge: 'https://ge.ecoflow.com/', //格鲁吉亚
        pt: 'https://ecoflow.com.pt/', // 葡萄牙
        ie: 'https://www.ecoflow.ie/', // 爱尔兰
        cz: 'https://ecoflow.cz/', // 捷克
        hr: 'https://www.ecoflow.hr/', // 克罗地亚
        si: 'https://www.ecoflow.si/', // 斯洛文尼亚
        gr: 'https://ecoflow.gr/', //希腊
        dk: 'https://www.ecoflow.dk/', // 丹麦
        no: 'https://www.ecoflow.no/', // 挪威
        kz: 'https://ecoflow.com.kz/', // 哈萨克斯坦
        // 拉美
        co: 'https://www.tienexenergy.co/', // 哥伦比亚
        ar: 'https://ecoflowstore.com.ar/', // 阿根廷
        cl: 'https://ecoflowchile.cl/',
        // 中东非
        ng: 'https://ng.ecoflow.com/', // 尼日利亚
        // 澳新
        nz: 'https://ecoflowtech.co.nz/', //新西兰
        // 亚太一区
        in: 'https://ecoflowindia.com/', // 印度
        // 亚太二区
        th: 'https://www.siamef.com/', // 泰国
        my: 'http://ecoflow.com.my/', // 马来西亚
        sg: 'http://ecoflow.com.sg/', // 新加坡
        id: 'https://powerstation-sts.id/', // 印尼
        vn: 'https://ecoflowvn.vn/', // 越南
    };
    // 发起点击
    const clickHandle = async () => {
        if (locale === 'cn') {
            //gotoCnHandle();
        } else {
            gotoShopifyHandle1();
        }
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'top_function',
                button_name: 'Store',
                __btn_id1: `${prefixCls}-bar-store`,
                __btn_id2: `header-store`,
                __btn_type: 'common',
                __is_shopify_href: true,
            });
        } catch (error) {}
    };
    // 去Shopify
    const gotoShopifyHandle1 = async () => {
        gotoShopifyHandle2();
    };
    const gotoShopifyHandle2 = async () => {
        const isMobile = isH5HandleClient(); //是否是移动端

        try {
            let url = '';
            switch (locale) {
                case 'cn':
                    url = 'https://mall.jd.com/index-1000363402.html';
                    break;
                case 'jp':
                    url = 'https://jp.ecoflow.com';
                    break;
                case 'cis':
                    url = 'https://ecoflow-russia.com/';
                    break;
                default:
                    if (locale === 'global') {
                        const countryCode: string = (localStorage.getItem('macIp') || '')
                            .trim()
                            .toLowerCase()
                            .replace(/^["']|["']$/g, '');
                        const hasOwnStoreSites = [
                            'us',
                            'ca',
                            'eu',
                            'uk',
                            'de',
                            'fr',
                            'it',
                            'es',
                            'nl',
                            'jp',
                            'kr',
                            'au',
                            'za',
                            'sa',
                            'br',
                            'mx',
                            'ph',
                        ].includes(countryCode);
                        if (hasOwnStoreSites) {
                            url = `https://${countryCode}.ecoflow.com`;
                        } else {
                            const storeURL = storeMap?.[countryCode];
                            if (storeURL) {
                                url = storeURL;
                            }
                        }
                    } else {
                        url = `https://${locale}.ecoflow.com`;
                    }
                    break;
            }
            const token = loginUser()?.token || '';
            if (token) {
                const res = await authSignIn({ url }, { locale, token });
                if (res.code === '0') {
                    url = res.data;
                    const urlArr = url.split('redirect=');
                    if (urlArr.length > 1) {
                        const redirectUrl = urlArr[1];
                        if (
                            redirectUrl.indexOf('.ecoflow.com') === -1 &&
                            (redirectUrl.indexOf('www.') !== -1 || redirectUrl.startsWith('https://') || redirectUrl.startsWith('http://'))
                        ) {
                            url = '/';
                        }
                    }
                }
            }
            // 第三方shopify登录，需要在cookie写入token信息，目前没有选择地区，暂时写us地区
            document.cookie = `us-token=${token};expires=7;` + `domain=.ecoflow.com;path=/`;
            if (isMobile) {
                saveAICookieForShopify(url, locale);
                if (locale === 'global') {
                    if (url) {
                        location.href = saveCookieForShopify(url, locale) || '';
                    } else {
                        location.href = saveCookieForShopify('/global/region', locale) || '';
                    }
                } else {
                    location.href = saveCookieForShopify(url, locale) || '';
                }
            } else {
                saveAICookieForShopify(url, locale);
                let winOpen: any;
                if (locale === 'global') {
                    if (url) {
                        //手机不使用window.open打开
                        winOpen = window.open('', '_blank');
                        winOpen.location = saveCookieForShopify(url, locale); //兼容safari浏览器
                    } else {
                        EcoDesignEventsBus.emit('GlobalLocaleV1-region-open');
                    }
                } else {
                    //手机不使用window.open打开
                    winOpen = window.open('', '_blank');
                    winOpen.location = saveCookieForShopify(url, locale); //兼容safari浏览器
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <>
            <button className={`${prefixCls}-bar-item ${prefixCls}-bar-store`} aria-label="store" onClick={clickHandle} data-btn-id="header-store">
                <span className={`${prefixCls}-bar-item-msg`}>{StoreTextA.store}</span>
                <StoreIconA />
            </button>
        </>
    );
}
